var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"FooterFixed",staticClass:"FooterFixed"},[_vm._t("ex_footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }